import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import Files from 'apps/files';
import Projects from 'apps/projects';

import { MainWrapper } from 'legacyComponents/styled/lib';
import RFQList from 'apps/rfq/rfqList';
import OrderList from 'apps/order/orderList';

const Dashboard = observer(() => {
  return (
    <>
      <Header />
      <MainWrapper id='main-wrapper' marginBottom='4em'>
        <Files maxItems={3} />
        <Projects maxItems={3} />
        <RFQList maxItems={3} disableSortingFilteringFeatures />
        <OrderList maxItems={3} disableSortingFilteringFeatures />
      </MainWrapper>
    </>
  );
});

export default withNamespaces()(Dashboard);
